export default __webpack_public_path__ + "static/media/ic-practice-test.f09edc52.svg";